import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { Controller } from "react-hook-form";
import { DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const DateInput = ({ label, name, control, disabled, disableFuture }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box component="div" sx={{ marginBottom: "20px", width: "100%" }}>
            <DatePicker
              disableFuture={disableFuture ?? true}
              value={value || null}
              label={label}
              onChange={(newValue) => onChange(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  name={name}
                  error={Boolean(error)}
                  helperText={error?.message}
                  disabled={disabled}
                />
              )}
            />
          </Box>
        </LocalizationProvider>
      )}
    />
  );
};

export const DateTimeInput = ({
  disablePast,
  label,
  name,
  control,
  shouldDisableDate,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box component="div" sx={{ marginBottom: "20px" }}>
            <DateTimePicker
              shouldDisableDate={shouldDisableDate}
              disablePast={disablePast ? true : false}
              value={value || null}
              label={label}
              onChange={(newValue) => onChange(newValue)}
              minutesStep={5}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  name={name}
                  error={Boolean(error)}
                  helperText={error?.message}
                />
              )}
            />
          </Box>
        </LocalizationProvider>
      )}
    />
  );
};

export const TimeInput = ({ label, name, control }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box component="div" sx={{ marginBottom: "20px" }}>
            <TimePicker
              disableFuture
              value={value || null}
              label={label}
              onChange={(newValue) => onChange(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  name={name}
                  error={Boolean(error)}
                  helperText={error?.message}
                />
              )}
            />
          </Box>
        </LocalizationProvider>
      )}
    />
  );
};

export const PasswordInput = ({ register, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <TextField
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              tabIndex={-1}
              onClick={() => setShow((show) => !show)}
              sx={{ width: "36px", height: "32px" }}
            >
              {show ? (
                <FontAwesomeIcon fontSize="medium" icon={faEyeSlash} />
              ) : (
                <FontAwesomeIcon fontSize="medium" icon={faEye} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
      {...register}
      {...props}
      type={!show ? "password" : "text"}
    />
  );
};

export default DateInput;
